// src/components/resources/tools/generators/AdMockup/Avatar.tsx
'use client'

import { clsx } from 'clsx'
import { initialsOf } from './ad-format'

/** Shared avatar block — uploaded image or colored initials. */
export function Avatar({ name, image, size = 40, ring }: { name: string; image: string | null; size?: number; ring?: boolean }): JSX.Element {
  return (
    <div
      className={clsx('flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-indigo-500 to-sky-500 font-semibold text-white', ring && 'p-[2px] ring-2 ring-pink-500 ring-offset-2')}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {image ? (
        // eslint-disable-next-line @next/next/no-img-element -- user-uploaded data URL; next/image can't optimize blob/data URIs and html2canvas needs the raw <img>
        <img src={image} alt={name} className="h-full w-full rounded-full object-cover" />
      ) : (
        <span>{initialsOf(name)}</span>
      )}
    </div>
  )
}
